"use client"

import { useState } from "react";
import GoodMarkdownParser from "./safeMarkedParser";

interface ExpandableCommentProps {
  content: string;
  limit?: number;
}

 const handleInteraction = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

const ExpandablePolicy = ({ content, limit = 50 }: ExpandableCommentProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const words = content.split(/\s+/);
  const isLong = words.length > limit;
  const excerpt = words.slice(0, limit).join(' ') + '...';

  return (
    <div className="w-full">
      <div className={`prose font-serif ${isLong ? "-mb-10" : "-mb-6"} prose-md text-lg max-w-none text-slate-700 leading-relaxed whitespace-pre-wrap`}>
        <GoodMarkdownParser content={isExpanded ? content : (isLong ? excerpt : content)} />
      </div>
      
      {isLong && (
        <button
            onClick={(e) => {
              handleInteraction(e);
              setIsExpanded(!isExpanded);
            }}
            className="text-[10px] translate-y-2 font-bold uppercase tracking-widest text-amber-800 hover:text-amber-600 transition-colors pointer-events-auto"
          >
            {isExpanded ? "↑ Show Less" : "↓ Expand Full Text"}
          </button>
      )}
    </div>
  ); 
};

export default ExpandablePolicy;